import React, { useCallback, useEffect, useState } from 'react'
import { DefaultVariant } from './DefaultVariant'
import { PromotionalVariant } from './PromotionalVariant'

export enum ModalPlanDetailsVariants {
  Default = 'default',
  Promotional = 'promotional'
}

const initialState = {
  isOpen: false,
  groupTier: '',
  variant: ''
}

export const ModalPlanDetails = () => {
  const [state, setState] = useState(initialState)

  const handleOnClose = useCallback(() => {
    setState(initialState)
  }, [])

  const handleOnClick = useCallback((event: Event) => {
    const target = event.target as HTMLElement
    const selectorTarget = '[data-group-tier][data-variant]'

    if (!target?.matches(selectorTarget)) return

    const { groupTier, variant } = target.dataset

    if (groupTier && variant) {
      setState({
        variant,
        groupTier,
        isOpen: true
      })
    }
  }, [])

  useEffect(() => {
    window.addEventListener('click', handleOnClick, {
      passive: true
    })

    return () => {
      window.removeEventListener('click', handleOnClick)
    }
  }, [handleOnClick])

  if (state.variant === ModalPlanDetailsVariants.Promotional) {
    return (
      <PromotionalVariant
        isOpen={state.isOpen}
        onClose={handleOnClose}
        groupTier={state.groupTier}
      />
    )
  }

  return (
    <DefaultVariant
      isOpen={state.isOpen}
      onClose={handleOnClose}
      groupTier={state.groupTier}
    />
  )
}
